import React, { createContext, useState, useEffect, useContext } from "react"
import { classApi } from "apis/ClassListApi"
import { AttendanceApi } from "apis/AttendanceApi"
import { SessionContext } from "./sessionContext"
export const AttendanceContext = createContext()

const AttendanceProvider = props => {
  const { Session } = useContext(SessionContext)
  let session_id = Session || sessionStorage.getItem("SessionId")

  const currentDate = new Date()
  const formattedDate = convertDate(currentDate.toISOString().slice(0, 10))

  //  take data from localstorage
  var myValue = JSON.parse(localStorage.getItem("User"))
  let teacher_code = myValue?.payload?.t_code ? myValue?.payload?.t_code : ""
  let get_class = myValue?.payload?.home_class
    ? myValue?.payload?.home_class
    : ""
  let get_section = myValue?.payload?.home_sec ? myValue?.payload?.home_sec : ""
  let class_teacher_classwise = `${get_class} ${get_section}`.trim()
  const [studentList, setStudentList] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [selectedDate, setSelectedDate] = useState(formattedDate)

  let attendanceDate = studentList?.attendence_date
  const [classList, setClassList] = useState([])
  const [subjectList, setSubjectList] = useState([])
  let classListOption = (classList || [])?.filter((list, index, arr) => {
    return index === arr.findIndex(d => d.label === list.label)
  })
  const [classSelect, setClassSelect] = useState(class_teacher_classwise || "")

  useEffect(() => {
    if ((!classSelect || classSelect.trim() === "") && classListOption && classListOption.length > 0) {
      setClassSelect(classListOption[0].label)
    }
  }, [classListOption, classSelect])

  function convertDate(data) {
    const dateString = data
    const date = new Date(dateString)
    const formattedDate = date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    return formattedDate
  }

  let handleclassselect = e => {
    setIsLoading(true)
    setStudentList([])
    setClassSelect(e.target.value)
  }
  const cleanClassSelect = classSelect?.trim() || ""
  const lastSpaceIndex = cleanClassSelect ? cleanClassSelect.lastIndexOf(" ") : -1
  let sel_class = lastSpaceIndex !== -1 ? cleanClassSelect.substring(0, lastSpaceIndex) : cleanClassSelect
  let sel_section = lastSpaceIndex !== -1 ? cleanClassSelect.substring(lastSpaceIndex + 1) : ""
  let class_teacher = cleanClassSelect === class_teacher_classwise && class_teacher_classwise !== ""
  let st_class = sel_class ? sel_class : get_class
  let st_sec = sel_section ? sel_section : get_section

  useEffect(() => {
    classApi
      .getAllClass()
      .then(res => {
        if (myValue == "Admin") {
          setClassList(
            res?.data?.section_list?.map(cl => {
              return {
                value: cl.UID,
                label: `${cl.st_class} ${cl.st_sec}`,
              }
            })
          )
          setSubjectList(
            res.data?.subject?.map(sub => {
              return {
                value: sub.uid,
                label: sub.subject_name,
              }
            })
          )
        }
      })
      .catch(err => {
        console.log(err)
      })
    if (myValue != "Admin") {
      setClassList(
        myValue?.teacher_subject?.map(cl => {
          return {
            value: cl.uid,
            label: `${cl.st_class} ${cl.st_sec}`,
          }
        })
      )
    }
  }, [])
  const handleDateChange = data => {
    setIsLoading(true)
    setStudentList([])
    const date = new Date(data)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    const formattedDate = `${year}-${month}-${day}`
    setSelectedDate(convertDate(formattedDate))
  }

  function attendanceListDate(data) {
    const date = new Date(data)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    const formattedDate = `${year}-${month}-${day}`
    return formattedDate
  }

  var attendence_date = attendanceListDate(selectedDate)
  let currentSessionId = Session || sessionStorage.getItem("SessionId") || session_id
  let data = {
    st_class,
    st_sec,
    attendence_date,
    teacher_code,
    session_id: currentSessionId,
    is_current_teacher: class_teacher === true ? "True" : "False",
  }
  function getList(reqData) {
    const activeSession = Session || sessionStorage.getItem("SessionId") || session_id
    const payload = {
      ...reqData,
      session_id: reqData?.session_id || activeSession,
    }
    AttendanceApi.getAllStudentList(payload)
      .then(res => {
        setStudentList(res.data)
        setIsLoading(false)
        localStorage.setItem("myattendance", JSON.stringify(res.data))
      })
      .catch(err => {
        const savedData = JSON.parse(localStorage.getItem("myattendance"))
        setStudentList(
          savedData || {
            student: [],
            present_list: [],
            absent_list: [],
            total_student: 0,
            present: 0,
            absent: 0,
          }
        )
        setIsLoading(false)
        console.log(err)
      })
  }
  useEffect(() => {
    getList({
      st_class,
      st_sec,
      attendence_date,
      teacher_code,
      session_id: Session || sessionStorage.getItem("SessionId") || session_id,
      is_current_teacher: class_teacher === true ? "True" : "False",
    })
  }, [selectedDate, st_class, st_sec, session_id, Session])

  return (
    <AttendanceContext.Provider
      value={{
        handleclassselect,
        classListOption,
        studentList,
        setStudentList,
        convertDate,
        attendanceDate,
        st_class,
        st_sec,
        studentList,
        setStudentList,
        convertDate,
        attendanceDate,
        st_class,
        st_sec,
        isLoading,
        handleclassselect,
        classListOption,
        selectedDate,
        handleDateChange,
        class_teacher,
        getList,
        data,
        classSelect,
        attendence_date,
        setIsLoading,
        session_id,
      }}
    >
      {props.children}
    </AttendanceContext.Provider>
  )
}
export const useClass = () => {
  return useContext(AttendanceContext)
}

export default AttendanceProvider
